import script from "./ContactSearchItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactSearchItem.vue?vue&type=script&lang=ts&setup=true"

import "./ContactSearchItem.vue?vue&type=style&index=0&id=0007bdc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0007bdc2"]])

export default __exports__